import { T } from '../../../../constants';
import { isMobile } from '../../../../helpers';
import { BoostedJackpotPrizePoolType, BoostedJackpotTimeType } from '../../boostedJackpotModule/boostedJackpot/index.types';

export const BoostedJackpotTime = (
  days: string,
  hours: string,
  isIcon: boolean,
  minutes: string,
  seconds: string,
  stylesTimer: any,
  stylesHider: any,
  marginInText: number,
  hiderTextXPosition: number,
): any | BoostedJackpotTimeType[] => {
  return [
    (+days || !isIcon) && [
      { text: days[0], textY: 60, textX: 0, stylesTimer },
      { text: days[1], textY: 60, textX: marginInText, stylesTimer },
      { text: T.DD, textY: isIcon ? isMobile() ? 70 : 72 : 98, textX: hiderTextXPosition, stylesHider },
    ],
    (+hours || +days || !isIcon) && [
      { text: hours[0], textY: 60, textX: 0, stylesTimer },
      { text: hours[1], textY: 60, textX: marginInText, stylesTimer },
      { text: T.HH, textY: isIcon ? isMobile() ? 70 : 72 : 98, textX: hiderTextXPosition, stylesHider },
    ],
    (!+days || !isIcon) && [
      { text: minutes[0], textY: 60, textX: 0, stylesTimer },
      { text: minutes[1], textY: 60, textX: marginInText, stylesTimer },
      { text: T.MM, textY: isIcon ? isMobile() ? 70 : 72 : 98, textX: hiderTextXPosition, stylesHider },
    ],
    ((!+days && !+hours) || !isIcon) && [
      { text: seconds[0], textY: 60, textX: 0, stylesTimer },
      { text: seconds[1], textY: 60, textX: marginInText, stylesTimer },
      { text: T.SS, textY: isIcon ? isMobile() ? 70 : 72 : 98, textX: hiderTextXPosition, stylesHider },
    ],
  ];
};

const formattedDate = (value: string): string => {
  if (!value) return '';
  const date: Date = new Date(value);
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(date);
};

const styles = {
  fontSize: 11,
  fontWeight: 700,
  fill: '#FFFFFF',
  align: 'center',
  fontFamily: 'poppinsMedium',
};

export const BoostedJackpotPrizePool = (
  lastWinnerDate: string,
  prizePoolAmount: number,
  lastWinnerAmount: number,
  largestWinnerDate: string,
  prizePoolLeftAmount: number,
  largestWinnerAmount: number,
): BoostedJackpotPrizePoolType[] => {
  return [
    {
      isHeader: true,
      option: {
        textX: 223,
        textY: 165,
        anchor: 0.5,
        style: styles,
        resolution: 2,
        text: T.PRIZE_POOL,
      },
    },
    {
      option: {
        textX: 185,
        textY: 205,
        margin: 40,
        fontSize: 34,
        text: prizePoolAmount,
      },
    },
    {
      isHeader: true,
      option: {
        textX: 225,
        textY: 243,
        anchor: 0.5,
        resolution: 2,
        style: styles,
        text: T.PRIZE_POOL_LEFT,
      },
    },
    {
      option: {
        textX: 205,
        textY: 270,
        margin: 20,
        text: prizePoolLeftAmount,
      },
    },
    {
      isHeader: true,
      option: {
        textX: 100,
        textY: 303,
        anchor: 0.5,
        resolution: 2,
        style: styles,
        text: T.LAST_WINNER,
      },
    },
    {
      isHeader: true,
      option: {
        textX: 100,
        textY: 350,
        anchor: 0.5,
        resolution: 2,
        style: styles,
        text: formattedDate(lastWinnerDate),
      },
    },
    {
      option: {
        textX: 85,
        textY: 330,
        margin: 20,
        text: lastWinnerAmount,
      },
    },
    {
      isHeader: true,
      option: {
        textX: 350,
        textY: 303,
        anchor: 0.5,
        resolution: 2,
        style: styles,
        text: T.LARGEST_WINNER,
      },
    },
    {
      isHeader: true,
      option: {
        textX: 350,
        textY: 350,
        anchor: 0.5,
        resolution: 2,
        style: styles,
        text: formattedDate(largestWinnerDate),
      },
    },
    {
      option: {
        textX: 327,
        textY: 330,
        margin: 20,
        text: largestWinnerAmount,
      },
    },
  ];
};

export const BoostedJackpotInfoPopupRulesKeys: any | Array<{ key: string, type: string, isSprite?: boolean }> = [
  { key: 'INTRO_DESCRIPTION_1', type: 'text' },
  { key: 'INTRO_DESCRIPTION_2', type: 'text' },
  { key: 'RULES_TITLE_1', type: 'title' },
  { key: 'RULES_DESCRIPTION_2', type: 'text' },
  { key: 'RULES_DESCRIPTION_3', type: 'text' },
  { key: 'RULES_DESCRIPTION_4', type: 'text' },
  { key: 'STATES_TITLE', type: 'title' },
  { key: 'STATE_1', type: 'text' },
  { key: 'STATE_2', type: 'text' },
  { key: 'STATE_3', type: 'text' },
  { key: null, type: null, isSprite: true },
  { key: 'VALIDATIONS_TITLE', type: 'title' },
  { key: 'VALIDATIONS_1', type: 'text' },
  { key: 'VALIDATIONS_2', type: 'text' },
];

export const ContainerConfigBoostedJackpot = {
  containerConfigBoostedJackpotWheel: {
    x: isMobile() ? 269 : 720,
    y: isMobile() ? 480 : 405,
  },
  containerConfigBoostedJackpotWinPopup: {
    x: isMobile() ? 270 : 720,
    y: isMobile() ? 525 : 406,
  },
  containerConfigBoostedJackpotInfoPopup: {
    x: isMobile() ? 27 : 478,
    y: isMobile() ? 200 : 86,
  },
  containerConfigBoostedJackpotInitialPopup: {
    x: isMobile() ? 22.5 : 341,
    y: isMobile() ? 300 : 148,
    scale: isMobile() ? 0.65 : 1,
  },
};
